export default class TotalMedia {
    constructor(
      public index: number = 0,
      public impressions: number = 0,
      public ratingPoints: number = 0,
    ) {}
  }
  